import { Component } from "@angular/core";

@Component({
  selector: "app-stock-number-modal",
  templateUrl: "./stock-number-modal.component.html",
  styleUrls: ["./stock-number-modal.component.scss"]
})
export class StockNumberModalComponent {}
